function handleTabIndex(cmp) {
    if (cmp.disabled) {
        // cache current tabindex
        cmp._tabIndex = cmp.el.tabIndex;
        // force to -1 for disabled elements
        cmp.el.tabIndex = -1;
    }
    else {
        // reset to cached local state
        cmp.el.tabIndex = cmp._tabIndex;
        // Prop takes precedence
        if (typeof cmp.tabIndex !== 'undefined') {
            cmp.el.tabIndex = cmp.tabIndex;
        }
    }
}

export { handleTabIndex as h };

//# sourceMappingURL=index8.js.map